import { render, staticRenderFns } from "./Ver2Home.vue?vue&type=template&id=1b915d28&scoped=true"
import script from "./Ver2Home.vue?vue&type=script&lang=js"
export * from "./Ver2Home.vue?vue&type=script&lang=js"
import style0 from "./Ver2Home.vue?vue&type=style&index=0&id=1b915d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b915d28",
  null
  
)

export default component.exports